import { featureFlagStore } from './utils/featureFlags/featureFlags';

export interface TestOptions {
    /**
     * Feature-flags to explicitly enable or disable for a test
     */
    featureFlags?: Record<string, boolean>;
}

export const init = (options: TestOptions = {}) => {
    const { featureFlags = {} } = options;
    Object.entries(featureFlags).forEach(([ key, value ]) => {
        featureFlagStore.set(key, value);
    });
};
